import script from "./SettlementCompletePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettlementCompletePanel.vue?vue&type=script&setup=true&lang=ts"

import "./SettlementCompletePanel.vue?vue&type=style&index=0&id=6d31889b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d31889b"]])

export default __exports__